<template>
  <div class="pc">
    <NuxtLayout name="nude">
      <div class="problem-wrap">
        <div class="problem-box">
          <div class="problem-inner">
            <div class="logo-area">
              <NuxtLink to="/"><img src="@/assets/images/pc/header-logo.png" alt="Hcon 현대이지웰 로고" /></NuxtLink>
            </div>
            <div class="box-border pt70 pb80">
              <img src="@/assets/images/pc/sub-hcon/img-page-error.png" class="problem-img" alt="">
              <h1 class="title">페이지 오류 안내</h1>
              <p class="desc">페이지 주소가 잘못 입력되었거나,<br/>일시적인 에러로 현재 사용하실 수 없습니다.<br/>다시 한 번 확인해주세요.</p>
              <div class="button-box gap8">
                <button type="button" @click="router.back()" class="btn btn-outline lg">이전 화면으로 이동</button>
                <NuxtLink to="/" class="btn lg">메인 화면으로 이동</NuxtLink>
              </div>
            </div>
            <p class="copyright">Copyright ⓒHYUNDAI EZWEL CO., LTD. All rights reserved.</p>
          </div>
        </div>
      </div>
    </NuxtLayout>
  </div>
</template>
<script lang="ts" setup>
import { useRouter } from 'vue-router'

const router    = useRouter();
</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/import-hcon.scss" as *;
@use "@/assets/scss/pc/pc-hcon.scss" as *;
@use "@/assets/scss/pc/etc-hcon.scss" as *;  
</style>